// import TileLayer from 'ol/layer/Tile';
// import TileWMS from 'ol/source/TileWMS';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { sharedPolygonSources } from './helpers';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';

export const getPolygonStyle = (fill, stroke, strokeWidth, font, fontColor) =>
{
    return new Style({
        fill: new Fill({ color: fill }),
        stroke: new Stroke({ color: stroke, width: strokeWidth }),
        text: new Text({
            font: font,
            fill: new Fill({color: fontColor}),
            stroke: new Stroke({color: 'rgba(255,255,255,1)', width: 2}),
        }),
    });
};

export const PROXY_PREFIX = `${process.env.VUE_APP_API_URL_ORIGIN}maphelper/proxy/`;
const getLegendByStyleName = style => PROXY_PREFIX + "http://geoserver.pathway.com.np/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&STRICT=false&style="+style;
// const getLegendByLayerName = layer => PROXY_PREFIX + `http://geoserver.pathway.com.np/geoserver/wms?Service=WMS&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=${layer}`

// we will need this to fake layer toggling
const navLayerStyles = {
    state: getPolygonStyle('rgba(0,0,0,0)', '#000', 1.5, `bold 14px times`, '#222'),
    district: getPolygonStyle('rgba(0,0,0,0)', '#555', 1, `normal 12.5px arial`, '#000'),
    municipality: getPolygonStyle('rgba(0,0,0,0)', '#ddd', 0.2, `normal 11px arial`, '#151515'),
};

// const defaultMunicipalityStyle = (feature, resolution) =>
// {
//     if (resolution < 0.001)
//     return new Style({
//         fill: new Fill({ color: 'rgba(255,255,255,0)' }),
//         stroke: new Stroke({ color: 'white', width: 0.4 }),
//         text: new Text({
//             text: feature.get('GaPa_NaPa'),
//             fill: new Fill({color: 'black'}),
//             stroke: new Stroke({color: 'rgba(255,255,255,1)', width: 2}),
//         }),
//     });
//     return;
// }

// export const resetMunicipalityStyle = () => adminLayers.municipality.setStyle(defaultMunicipalityStyle);

// this navigationlayers are the admin layers used in MapNavigator
export const navigationLayers = {
    state: new VectorLayer({
        id : "state",
        titleEnglish: "Province",
        titleNepali: "प्रदेश",
        legendPath: getLegendByStyleName("AdolFertility:province"),
        sourceInfo: 'Survey Department',
        description: 'Provincial boundary of the federal democratic\nrepublic of Nepal. It has 7 administrative units.',
        sourceInfoNepali: 'नापी विभाग',
        descriptionNepali: 'संघीय लोकतान्त्रिक गणतन्त्र नेपालको प्रान्तीय सीमा',
        visible: true,
        opacity: 0.9,
        source: sharedPolygonSources.state,
        style: navLayerStyles.state,
        zIndex: 2.3,
    }),
    district: new VectorLayer({ 
        zIndex: 2.2,
        source: sharedPolygonSources.district,
        style: navLayerStyles.district,
    }),
    municipality: new VectorLayer({
        zIndex: 2.1,
        source: sharedPolygonSources.municipality,
        style: navLayerStyles.municipality,
    }),
    soloMunicipality: new VectorLayer({
        source: new VectorSource(),
        style: getPolygonStyle('rgba(0,0,0,0)', '#888', 1),
        zIndex: 2.0,
    }),
    hoveredFeatureLayer: new VectorLayer({
        source: new VectorSource(),
        style: getPolygonStyle('rgba(0,0,0,0.175)', 'rgba(0,0,0,0)', 2),
        zIndex: 1000
    }),
    highlightedLayer: new VectorLayer({
        source: new VectorSource(),
        style: getPolygonStyle('rgba(255,255,255,0)', 'rgba(255,255,255,1)', 2),
        zIndex: 1001,
    }),
};

const getDistinctPropertyList = (layer, property) =>
{
    return layer.getSource().getFeatures().map(ftr => ftr.get(property)).filter((val, index, self) => self.indexOf(val)===index);
}

export const setNavLayerStyles = (stateLabelField, districtLabelField, muniLabelField) =>
{
    const stateTextStyle = navLayerStyles.state.getText();
    const districtTextStyle = navLayerStyles.district.getText();
    let oldResolutionState = null;
    let scodesToExcludeCache = [];
    navigationLayers.state.setStyle( (feature,resolution, ) =>
    {
        // only if resolution change will we recalculate scodesToExclude else we will use the scodesToExcludeCache
        // if we don't do this, the calculation to getDistinctProperty list and scodes from municipality will be
        // called for every feature
        if (oldResolutionState!==resolution)
        {
            const scodesFromDistricts = getDistinctPropertyList(navigationLayers.district, 'SCode');
            const scodesFromMunicipalities = getDistinctPropertyList(navigationLayers.municipality, 'SCode');
            scodesToExcludeCache = [...scodesFromDistricts, ...scodesFromMunicipalities];
        }
        oldResolutionState = resolution;

        if ( scodesToExcludeCache.indexOf( feature.get('SCode') ) !== -1)
        {
            stateTextStyle.setText('');
        }
        else
        {
            stateTextStyle.setText(feature.get(stateLabelField));
        }
        return navLayerStyles.state; 
    });

    let oldResolutionDistrict = null;
    let dcodesToExcludeCache = [];
    navigationLayers.district.setStyle((feature,resolution) =>
    {
        if (resolution!==oldResolutionDistrict)
        {
            dcodesToExcludeCache = getDistinctPropertyList(navigationLayers.municipality, 'DCode');
        }
        oldResolutionDistrict = resolution;

        if ( dcodesToExcludeCache.indexOf( feature.get('DCode') ) !== -1)
        {
            districtTextStyle.setText('');
        }
        else
        {
            districtTextStyle.setText(feature.get(districtLabelField));
        }
        return navLayerStyles.district;
    });
    navigationLayers.municipality.setStyle(feature =>
    {
        navLayerStyles.municipality.getText().setText(feature.get(muniLabelField));
        return navLayerStyles.municipality;
    });
};

// setNavLayerStyles();


// export const adminLayers = {
//     country: new TileLayer({
//         id : "country",
//         zIndex: 2.7,
//         titleEnglish: "Country",
//         titleNepali: "देश",
//         legendPath: getLegendByLayerName("nepal:country"),
//         sourceInfo: 'Survey Department',
//         description: 'Country boundary of the federal democratic\nrepublic of Nepal',
//         sourceInfoNepali: 'नापी विभाग',
//         descriptionNepali: 'संघीय लोकतान्त्रिक गणतन्त्र नेपालको देश सीमा',
//         visible: true,
//         source: new TileWMS({
//             url: "http://geoserver.pathway.com.np/geoserver/nepal/wms",
//             params: {
//                 "VERSION": "1.1.1",
//                 "LAYERS": "nepal:country",
//             }
//         }),
//     }),
//     state: navigationLayers.state,
//     district: new TileLayer({
//         id : "district",
//         zIndex: 2.5,
//         titleEnglish: "District",
//         titleNepali: "जिल्ला",
//         legendPath: getLegendByStyleName("AdolFertility:district&RULE=RULE2"),
//         sourceInfo: 'Survey Department',
//         description: 'District boundary of the federal democratic\nrepublic of Nepal. It has 77 administrative units.',
//         sourceInfoNepali: 'नापी विभाग',
//         descriptionNepali: 'संघीय लोकतान्त्रिक गणतन्त्र नेपालको जिल्ला सीमा',
//         visible: false,
//         source: new TileWMS({
//             "url": "http://geoserver.pathway.com.np/geoserver/AdolFertility/wms",
//             "params": {
//                 "VERSION": "1.1.1",
//                 "LAYERS": "AdolFertility:district",
//                 "STYLES": "AdolFertility:district"
//             }
//         })
//     }),
//     municipality: new VectorLayer({
//         id : "municipality",
//         zIndex: 2.15,
//         titleEnglish: "Municipality",
//         titleNepali: "पालिका",
//         legendPath: getLegendByStyleName("AdolFertility:gapanapa&RULE=RULE2"),
//         sourceInfo: 'Survey Department',
//         description: 'Municipal boundary of the federal democratic\nrepublic of Nepal. It has 753 rural & urbal municipalities.\nAnd is visible at 1: 1,000,000 scale',
//         sourceInfoNepali: 'नापी विभाग',
//         descriptionNepali: 'संघीय लोकतान्त्रिक गणतन्त्र नेपालको नगरपालिका सीमा',
//         visible: false,
//         source: new VectorSource(),
//         style: defaultMunicipalityStyle
//         // source: new TileWMS({
//         //     "url": "http://geoserver.pathway.com.np/geoserver/AdolFertility/wms",
//         //     "params": {
//         //         "VERSION": "1.1.1",
//         //         "LAYERS": "AdolFertility:gapanapa",
//         //         "STYLES": "AdolFertility:gapanapa"
//         //     }
//         // })
//     })
// };

export const allAdminLayers = [
    ...Object.values(navigationLayers),
    // adminLayers.country,
    // adminLayers.district,
    // adminLayers.municipality,
];


// export const setAdminLayerOpacity = ({id, opacity, visible}) =>
// {
//     opacity = visible ? parseFloat(opacity) : 0;
//     console.assert(Object.keys(adminLayers).includes(id), `Invalid division id ${id}`);
//     adminLayers[id].setOpacity(opacity);
//     adminLayers[id].setVisible(true);
// };

// export const updateAdminLayerLanguage = language =>
// {
//     const { district } = adminLayers;
//     if (language==="nepali")
//     {
//         district.getSource().updateParams({STYLES: "AdolFertility:district_nepali"});
//     }
//     else
//     {
//         district.getSource().updateParams({STYLES: "AdolFertility:district"});
//     }
// };